export default "__VITE_ASSET__PrioscPq__"